import TencentData from './tencent.data'
import { isMarketOpen, marketRequest } from './marketRefresh'

export function workspaceChartFilter(onError = () => {}, onQuote = () => {}, managed = false) {
  const loaded = new Set()
  const failures = new Map()
  const filter = async (data, callback) => {
    if (document.hidden) { data.PreventDefault = true; return }
    const kind = { 'MinuteChartContainer::RequestMinuteData':'minute', 'MinuteChartContainer::RequestHistoryMinuteData':'days', 'KLineChartContainer::RequestHistoryData':'kline', 'KLineChartContainer::RequestRealtimeData':'kline' }[data.Name]
    // HQChart minute requests carry [symbol]; K-line requests carry a string (same as H5).
    const symbol = Array.isArray(data.Request.Data.symbol) ? data.Request.Data.symbol[0] : data.Request.Data.symbol
    const period = data.Self.Period || 0, right = data.Self.Right || 0
    const key = `${symbol}:${kind}:${period}:${right}`
    if (!kind) { TencentData.NetworkFilter(data, callback); return }
    const initial = !loaded.has(key)
    data.PreventDefault = true
    const market = /\.USA?$/i.test(symbol) ? 'us' : /\.HK$/i.test(symbol) ? 'hk' : 'cn'
    const realtime = data.Name === 'KLineChartContainer::RequestRealtimeData'
    if ((realtime || (!initial && kind === 'minute')) && !isMarketOpen(market)) return
    try {
      const params = { code: TencentData.ConverToQQSymbol(symbol), kind, period: ['day','week','month'][period], right }
      const value = await marketRequest('chart-' + kind, params)
      if (data.Self.IsDestroy) return
      if (!value || !value.data) throw new Error('图表首载失败')
      loaded.add(key)
      if (kind === 'minute') TencentData.RecvMinuteData(value, data, callback, TencentData.GetMinuteApiUrl(symbol, 1))
      else if (kind === 'days') TencentData.RecvMinuteDaysData(value, data, callback, TencentData.GetMinuteApiUrl(symbol, 5))
      else if (data.Name === 'KLineChartContainer::RequestRealtimeData') TencentData.RecvRealtimeData(value, data, callback, TencentData.GetKDayApiUrl(symbol, period, right, 320))
      else TencentData.RecvHistoryData(value, data, callback, TencentData.GetKDayApiUrl(symbol, period, right, 320))
      const stock = value.data[params.code]
      if (stock && stock.qt) onQuote(stock.qt, params.code)
      onError('')
      failures.delete(key)
    } catch (error) {
      if (!data.Self.IsDestroy && !error.isAuthExpired) {
        const count = (failures.get(key) || 0) + 1
        failures.set(key, count)
        onError('图表数据暂不可用，请稍后重试')
        callback(kind === 'minute' ? { code:0, stock:[] } : { code:0, data:[] })
        if (!managed && count <= 2) setTimeout(() => { if (!data.Self.IsDestroy && !document.hidden) filter(data, callback) }, 2000)
      }
    }
  }
  return filter
}
